// orderUtils.js

export function generateOrderServices({
  cartItems = [],
  selectedService,
  shopDetails = {},
}) {
  const matchedItems = shopDetails?.matchedItems || [];
  let services = [];

  // Helper: Group items by name
  const groupByName = (items) =>
    items.reduce((acc, item) => {
      (acc[item.name] = acc[item.name] || []).push(item);
      return acc;
    }, {});

  if (selectedService === "Tailoring") {
    const orderItemRaw = matchedItems
      .flatMap((item) => item.matches || [])
      .map((match, index) => {
        const payloadMatch = cartItems.find((p) => p.name === match.cloth_name);
        return {
          id: match.id || index,
          name: match.cloth_name || "",
          service: match.serviceType || "",
          category: match.category || "",
          amount: match.tailoringType?.price || 0,
          tailoringType: {
            name: match.tailoringType?.name || "",
            price: match.tailoringType?.price || 0,
          },
          qty: payloadMatch?.weight || 1,
          icon: shopDetails?.image || "",
        };
      });

    const grouped = groupByName(orderItemRaw);

    services = [
      {
        service_type: serviceTypeValueToLabel(selectedService),
        estimated_weight_or_qty: Object.keys(grouped).length,
        notes: "Handle with care, delicate fabric",
        items: Object.entries(grouped).map(([itemName, items]) => ({
          quantity: items[0].qty,
          item_name: itemName,
          item_type: items[0].service,
          price: items.reduce((sum, i) => sum + (i.amount || 0), 0),
          tailoring_types: items.map((i) => ({
            name: i.tailoringType.name,
            price: i.amount,
          })),
        })),
      },
    ];
    return services;
  }

  // For other services
  const orderItem = matchedItems.map((item, index) => {
    const match = item?.match || {};
    let payloadMatch = {};

    if (selectedService === "Wash & Fold") {
      payloadMatch = cartItems.find((p) => p.name === match.category);
    } else {
     
      payloadMatch = cartItems.find((p) => p.name === match.cloth_name);
     
    }

    return {
      id: match.id || index,
      name:
        selectedService === "Wash & Fold"
          ? payloadMatch?.name
          : payloadMatch?.name,
      service: match.serviceType || "",
      category: match.category || "",
      amount: (match.price || 0) * (Number(payloadMatch?.weight) || 0),
      qty: Number(payloadMatch?.weight) || 1,
      instruction: payloadMatch?.instruction || "N/A",
    };
  });

  services = [
    {
      service_type: serviceTypeValueToLabel(selectedService),
      estimated_weight_or_qty: orderItem.reduce(
        (sum, item) => sum + item.qty,
        0
      ),
      notes: "Handle with care, delicate fabric",
      items: orderItem.map((item) => ({
        quantity: item.qty,
        price: item.amount,
        item_name: item.name,
        item_type: serviceTypeValueToLabel(selectedService),
      })),
    },
  ];

  return services;
}

export function generateOrderPayload({
  pickupDetails,
  orderItems,
  shopDetails,
  payloadAddress,
  userId,
  paymentBreakDown,
  tip,
  totalToPay,
  selectedAddOns = [],
}) {
  const pickupTimeParts = pickupDetails?.pickupTime?.split(" - ") || [];
  const deliveryTimeParts = pickupDetails?.deliveryTime?.split(" - ") || [];
  const payload = {
    payment_breakdown: {
      orderAmount: paymentBreakDown?.orderAmount,
      discount: paymentBreakDown?.discount,
      tax: paymentBreakDown?.tax,
      platformFee: paymentBreakDown?.platformFee,
      deliveryCharge: paymentBreakDown?.deliveryCharge,
      total_amount: totalToPay || 0,
      storeId: shopDetails?.id,
      serviceType: orderItems?.[0]?.service_type || "",
      pricingTierDiscount: shopDetails?.orignalPrice ? shopDetails?.orignalPrice - shopDetails?.totalPrice : 0,
      tip: tip || 0,
      campaignDiscount:paymentBreakDown?.discount || 0,
    },
    user_id: userId,
    store_id: shopDetails?.id || null,
    repeat_frequency: pickupDetails?.repeatFrequency || "",
    total_amount: totalToPay || 0,
    campaign_id: parseInt(paymentBreakDown?.campaignId) || null,
    pricing_tier_id: parseInt(shopDetails?.pricingTierUsed?.id) || null,
    status: "Pending",
    pickup: {
      tip:tip,
      pickup_date: pickupDetails?.pickupDate,
      pickup_time_slot: {
        open: pickupTimeParts[0] || "",
        close: pickupTimeParts[1] || "",
        note: "",
      },
      pickup_address: {
        address_line: payloadAddress?.house_no || "",
        city: payloadAddress?.city || "",
        state: payloadAddress?.state || "",
        pincode: payloadAddress?.zipcode || "",
        landmark: payloadAddress?.landmark || "",
        lat: payloadAddress?.latlongs[0]?.latitude || "",
        long: payloadAddress?.latlongs[0]?.longitude || "",
      },
      delivery_date: pickupDetails?.deliveryDate,
      delivery_time_slot: {
        open: deliveryTimeParts[0] || "",
        close: deliveryTimeParts[1] || "",
        note: "",
      },
      //  delivery_address: shopDetails?.storeAddress,
      delivery_address: {
        address_line:
          shopDetails?.storeAddress?.house_no +
          ", " +
          shopDetails?.storeAddress?.street_address,
        city: shopDetails?.storeAddress?.city || "",
        state: shopDetails?.storeAddress?.state || "",
        pincode: shopDetails?.storeAddress?.zipcode || "",
        landmark: shopDetails?.storeAddress?.landmark || "",
        lat: shopDetails?.storeAddress?.latlongs[0]?.latitude || "",
        long: shopDetails?.storeAddress?.latlongs[0]?.longitude || "",
      },
      pickup_status: "Pending",
    },
    services: orderItems,
    description:pickupDetails?.notes || "",
    laundryNotes: pickupDetails?.laundryNotes || "",
  };

    if (selectedAddOns?.length > 0) {
    payload.additional_items = selectedAddOns.map((item) => ({
      id: item.id,
      name: item.name,
      quantity: item.qty,
      unit_price: parseFloat(item.price.replace("$", "")) || 0,
    }));
  }

  return payload;
}

export const serviceTypeValueToLabel = (value) => {
  switch (value) {
    case "Dry Cleaning":
      return "DRYCLEANING";
    case "Tailoring":
      return "TAILORING";
    case "Wash & Fold":
      return "WASH_N_FOLD";
    default:
      return value;
  }
};
